<template>
  <IconLucideVideo />
</template>
